import { render } from "./MedbisOrderPage.vue?vue&type=template&id=7fbf4cd6&scoped=true"
import script from "./MedbisOrderPage.vue?vue&type=script&lang=js"
export * from "./MedbisOrderPage.vue?vue&type=script&lang=js"

import "./MedbisOrderPage.vue?vue&type=style&index=0&id=7fbf4cd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbf4cd6"]])

export default __exports__